import type { ReactNode } from "react";
import type { ClientBranding } from "../api/types";
import { Card } from "../ui";
import { DEFAULT_BRANDING } from "./branding";

/** Centered card used by the sign-in family of pages, branded for the requesting client. */
export function AuthShell({
  branding,
  title,
  children,
}: {
  branding: ClientBranding;
  title: string;
  children: ReactNode;
}) {
  // No client asked for this page, so it is Intelibo's own sign-in: show the company wordmark
  // people know from intelibo.com rather than a placeholder square and its name in text.
  const isIntelibo = branding === DEFAULT_BRANDING;
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center p-4">
      <div className="mb-6 flex items-center gap-3">
        {isIntelibo ? (
          <img src="/intelibo-logo.svg" alt="Intelibo" className="h-9 w-auto" />
        ) : (
          <>
            {branding.logo_url ? (
              <img
                src={branding.logo_url}
                alt=""
                className="h-9 w-9 rounded-md"
              />
            ) : (
              <span
                className="inline-block h-9 w-9 rounded-md"
                style={{ background: branding.primary_color ?? "#302a7c" }}
              />
            )}
            <span className="text-lg font-semibold tracking-tight">
              {branding.name}
            </span>
          </>
        )}
      </div>
      <Card className="shadow-card-lg">
        <h1 className="mb-4 text-xl font-semibold tracking-tight">{title}</h1>
        {children}
      </Card>
      {branding.support_url ? (
        <p className="mt-4 text-center text-xs text-slate-500">
          Need help?{" "}
          <a className="text-brand underline" href={branding.support_url}>
            Contact support
          </a>
        </p>
      ) : null}
    </main>
  );
}
